module.exports = __webpack_public_path__ + "img/10.dbdf461c.png";